import {INotification} from "../../../providers/NotificationProvider";
import logoSuggestion from "../../../assets/png/logoSuggestion.png";

const NotificationRouteSuggestionItem = ({ driverName, createdAt, destinyName, type }: INotification) => {
  const routeTypeTexts = {
    'SUGGESTED_ROUTE_FASTEST': 'Rota mais rápida',
    'SUGGESTED_ROUTE_ECONOMIC': 'Rota mais econômica',
    'SUGGESTED_ROUTE_LESS_CONSUMPTION': 'Rota com menor consumo energético',
    'SUGGESTED_ROUTE_NOT_MAPPED': 'Rota sugerida ainda não mapeada'
  };

  const routeTypeText = type && routeTypeTexts[type as keyof typeof routeTypeTexts]
    ? routeTypeTexts[type as keyof typeof routeTypeTexts]
    : 'Rota sugerida ainda não mapeada';

  return (
    <div className="padding-y-15 padding-x-25">
      <div>
        <span className="text-size-12 text-color-dark text-bold line-height-20">Viagem em andamento</span>
      </div>

      <div className="display-flex align-items-center gap-15 padding-y-10">
        <img src={logoSuggestion} alt="Logo Sugestão" className="width-40 height-40" />

        <div>
          <div className="display-flex gap-10 align-items-center">
            <span className="text-bold text-size-14 line-height-20 text-capitalize">Sugestão de rota</span>
            <div className="width-4 height-4 bg-black rounded"/>
            <span className="text-bold text-size-14 text-color-success">{routeTypeText}</span>
          </div>

          <div className="display-flex gap-10 align-items-center">
            <div className="display-flex gap-4 align-items-center">
              <span className="rioglyph rioglyph-user text-size-12 text-color-gray"></span>
              <span className="text-size-12 line-height-20 text-normal">{driverName}</span>
            </div>
            <div className="width-4 height-4 bg-black rounded" />
            <div className="display-flex gap-4 align-items-center">
              <span className="rioglyph rioglyph-finish text-size-14 text-color-gray"></span>
              <span className="text-size-12 line-height-20 text-normal">{destinyName}</span>
            </div>
          </div>

        </div>


      </div>
    </div>
  )
}

export default NotificationRouteSuggestionItem;